export default "__VITE_ASSET__Cpc8agOU__"